import React from 'react';
import ArticlePage from '../../components/article-page';
import { getProp, getPropAsset, getPropMarked } from '../utils';

const ArticlePagePreview = (props) => {
  const title = getProp(props, 'title');
  const date = getProp(props, 'date');
  const image = getPropAsset(props, 'image');
  const abstract = getPropMarked(props, 'abstract');
  const link = getProp(props, 'link');
  const pdf = getPropAsset(props, 'pdf');

  return (
    <div className="container-xl pt-5">
      <ArticlePage {...{ title, date, image, abstract, link, pdf }} />
    </div>
  );
};

export default ArticlePagePreview;
